<template>
  <div>
    <div class="sales-report" style="padding-top: 12px !important;">
      <div class="settings-top-bar sticky-header">
        <div class="top-bar">
          <p>
            <a class="btn btn-orange btn-icon back banner-back-button" :title="$t('general.back')" href="#" @click.prevent="goBackToReport">
              <i class="ti-arrow-left"></i>
              {{ $t('general.back') }}
            </a>
          </p>
          <p class="nexus-items-order-id">
            {{ $t('general.orderId') }}: <strong>{{ orderId }}</strong>
          </p>
        </div>
      </div>

      <div class="col-md-12 card text-left">
        <div class="card-content total-pagination pad-1">
          <div class="nexus-items-table-wrap">
            <el-table
              v-loading="loading"
              :data="items"
              :empty-text="$t('reports.noDataAvailable')"
              class="report-sales"
              style="width: 100%"
            >
              <el-table-column prop="id" label="ID" :min-width="70"></el-table-column>

              <el-table-column prop="order_id" :label="$t('reports.orderId')" :min-width="100">
                <template slot-scope="scope">
                  {{ scope.row.order_id || orderId }}
                </template>
              </el-table-column>

              <el-table-column prop="data_to" :label="$t('charisma.dataTo')" :min-width="220">
                <template slot-scope="scope">
                  <span style="display:block;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:12px;color:#303133;">{{ truncate(scope.row.data_to) }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="data_from" :label="$t('charisma.dataFrom')" :min-width="220">
                <template slot-scope="scope">
                  <span style="display:block;max-width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:12px;color:#303133;">{{ truncate(scope.row.data_from) }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="created_at" :label="$t('charisma.createDate')" :min-width="160">
                <template slot-scope="scope">
                  {{ formatToCompanyTimezone(scope.row.created_at, timezone) }}
                </template>
              </el-table-column>

              <el-table-column prop="actions" :label="$t('marketingCampaigns.actions')" :min-width="120">
                <template slot-scope="scope">
                  <a
                    class="btn btn-icon btn-info"
                    :title="$t('general.visualize')"
                    @click.prevent="openLogModal(scope.row)"
                  >
                    <i class="ti-eye"></i>
                  </a>
                </template>
              </el-table-column>
            </el-table>

            <div class="nexus-items-pagination">
              <el-pagination
                :current-page="currentPage"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                layout="prev, pager, next, sizes, total"
                :total="total"
                @current-change="onPageChange"
                @size-change="onPageSizeChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Log detail modal -->
    <vmodal
      name="nexusLogModal"
      height="auto"
      width="1200"
      :adaptive="true"
      :scrollable="true"
      class="nexus-log-modal"
    >
      <div class="card" style="margin: 0; position: relative;">
        <a
          class="btn btn-icon btn-default nexus-modal-close"
          @click.prevent="$modal.hide('nexusLogModal')"
        >
          <i class="ti-close"></i>
        </a>
        <div class="card-content" style="padding-top: 40px;">
          <div class="modal-header slim-header" style="text-align: center;">
            <h4>{{ $t('reports.nexusItems') }} #{{ selectedLog && selectedLog.id }} — {{ $t('general.orderId') }}: {{ orderId }}</h4>
          </div>
          <div class="modal-body" style="padding: 15px 0;">
            <div class="row">
              <div class="col-md-6">
                <label style="font-weight:600;">{{ $t('charisma.dataTo') }}</label>
                <el-input
                  type="textarea"
                  :rows="24"
                  disabled
                  :value="selectedLog && prettyJson(selectedLog.data_to)"
                  :placeholder="$t('charisma.dataTo')"
                ></el-input>
              </div>
              <div class="col-md-6">
                <label style="font-weight:600;">{{ $t('charisma.dataFrom') }}</label>
                <el-input
                  type="textarea"
                  :rows="24"
                  disabled
                  :value="selectedLog && prettyJson(selectedLog.data_from)"
                  :placeholder="$t('charisma.dataFrom')"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>

<script>
import swal from 'sweetalert2'

export default {
  name: 'NexusItems',
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    activeRoute () {
      return (this.route && this.route.params) ? this.route : this.$route
    },
    orderId () {
      return this.activeRoute.params.orderId || '-'
    }
  },
  watch: {
    orderId (newVal, oldVal) {
      if (String(newVal || '') === String(oldVal || '')) return
      this.currentPage = 1
      this.fetchItems()
    }
  },
  data () {
    return {
      loading: false,
      items: [],
      selectedLog: null,
      timezone: null,
      currentPage: 1,
      pageSize: 20,
      total: 0
    }
  },
  created () {
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest'
    this.fetchItems()
  },
  methods: {
    goBackToReport () {
      const orderId = this.activeRoute.params.orderId
      this.$bus.$emit('refresh', orderId)
      this.$bus.$emit('close-modal')
    },
    fetchItems () {
      const orderId = this.activeRoute.params.orderId
      if (!orderId) return
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.loading = true
      const url = `/nexus/logs/${orderId}?page=${this.currentPage}&perPage=${this.pageSize}`
      this.apiRequest(url, 'GET', data, (response) => {
        if (response && response.status) {
          this.items = Array.isArray(response.data) ? response.data : []
          if (response.pagination) {
            this.total = response.pagination.total || 0
            this.currentPage = response.pagination.page || 1
            this.pageSize = response.pagination.perPage || this.pageSize
          }
        } else {
          this.items = []
          this.total = 0
          swal(
            '',
            response && response.errors && response.errors['id']
              ? response.errors['id']
              : this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    onPageChange (page) {
      this.currentPage = page
      this.fetchItems()
    },
    onPageSizeChange (size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchItems()
    },
    openLogModal (row) {
      this.selectedLog = row
      this.$modal.show('nexusLogModal')
    },
    truncate (val, len = 80) {
      if (!val) return '-'
      const str = typeof val === 'string' ? val : JSON.stringify(val)
      return str.length > len ? str.slice(0, len) + '…' : str
    },
    prettyJson (val) {
      if (!val) return ''
      try {
        const parsed = typeof val === 'string' ? JSON.parse(val) : val
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return typeof val === 'string' ? val : JSON.stringify(val)
      }
    }
  }
}
</script>

<style scoped>
.nexus-items-table-wrap {
  width: 100%;
  overflow-x: auto;
}
.nexus-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
}
.nexus-items-pagination {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}
.nexus-items-order-id {
  margin: 0 0 0 auto;
  font-size: 14px;
  color: #25396F;
}
.settings-top-bar .top-bar {
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>

<style>
/* Prevent sticky back-bar from overlaying vmodal (unscoped to beat global .sticky-header) */
.sales-report .settings-top-bar.sticky-header {
  z-index: 10 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/NexusItems.vue